<!--  -->
<template>
  <div class="re_box">
    <el-card class="box-card">
      <!-- 选择区 -->
      <div class="selectionArea">
        <div class="item">
          <el-input
            v-model="query.name"
            style="width: 300px;"
            placeholder="配置名称"
          />
        </div>
        <div class="item">
          <el-select
            v-model="query.status"
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="item">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            @click="search"
          >搜索</el-button>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
          <el-button
            size="mini"
            type="success"
            icon="el-icon-s-help"
            @click="creater"
          >创建</el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        max-height="500"
      >
        <el-table-column
          prop="id"
          label="ID"
          width="300"
          align="center"
        />
        <el-table-column
          prop="name"
          label="规则名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="is_open_str"
          label="是否开启"
          width="180"
          align="center"
        />
        <el-table-column
          prop="event_type_text"
          label="事件类型"
          width="180"
          align="center"
        />
        <el-table-column
          prop="is_all_account_str"
          label="回传全部账户"
          width="300"
          align="center"
        />
        <el-table-column
          prop="status"
          label="状态"
          width="100"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="edit(scope.row)"
            >编辑</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="bandwechat(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        :title="'广告回传配置'"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="60%"
        :append-to-body="true"
      >
        <returndialog
          ref="returndialogview"
          @updata="updata"
        />
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { iqiyireportrulelist, iqiyireportruledelete } from '@/api/customer'
import PaginationRight from '@/components/PaginationRight/index.vue'
import returndialog from './components/returndialog.vue'
export default {
  components: { PaginationRight, returndialog },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        name: '',
        status: '',
        created_at: ''
      },
      tableData: [],
      total: null,
      dialogVisible: false,
      options: [
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '下架'
        }
      ]
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    async list() {
      const data = await iqiyireportrulelist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    search() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.name = ''
      this.query.status = ''
      this.query.created_at = ''
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },

    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    creater() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.returndialogview.send(1)
      })
    },
    updata() {
      this.dialogVisible = false
      this.list()
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.returndialogview.send(2, item)
      })
    },
    bandwechat(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          iqiyireportruledelete({
            id: id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.list()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.re_box {
  padding: 30px;
}
.channelManagement {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  /* flex-wrap: wrap; */
  /* justify-content: space-between; */
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(33.33% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
</style>
